import { AddressResponseT, RegistrationAddressT } from '../../types';

export const deserializeAddress = (addressResponse: AddressResponseT): RegistrationAddressT => {
  return {
    addressLine1: addressResponse.line1,
    addressLine2: addressResponse.apt_or_unit_number,
    city: addressResponse.city,
    postalCode: addressResponse.postal_code,
    state: addressResponse.region,
  };
};
